export default "__VITE_ASSET__f18339c1__"